<span class="text-3xl">{{ 'opportunities.title' | translate }}</span>

<p>{{ 'opportunities.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'opportunities.button.action' | translate }}
</button>
